import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";

// const options = [
//   // {
//   //   label: "What best describes you?",
//   //   // value: "1",
//   // },
//   {
//     label: "Individual Pro",
//     value: "individual",
//   },
//   {
//     label: "Bussiness Pro",
//     value: "bussiness",
//   },
// ];
export const generateSingleOptions = (optionsUserType) => {
  return optionsUserType.map((option) => {
    return (
      <MenuItem key={option.value} value={option.value}>
        {option.label}
      </MenuItem>
    );
  });
};

export const FormInputDropdown = ({
  name,
  control,
  label,
  value,
  options,
  rule,
}) => {
  return (
    <FormControl size={"small"}>
      <InputLabel>{label}</InputLabel>
      <Controller
        rules={rule}
        render={({ field: { onChange, value } }) => (
          <Select onChange={onChange} value={value}>
            {generateSingleOptions()}
          </Select>
        )}
        control={control}
        name={name}
      />
    </FormControl>
  );
};
